import { ILegalGroup } from './../../../models/response/legal-document/ILegalGroup';
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { legalGroupApi } from "../../../api/legalGroupApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { actions } from '../../actions/actionsWrapper';
import { eLegalGroupActionTypeIds, ILegalGroupActionTypes } from './../../action-types/legal-document/ILegalGroupActionTypes';

export function* legalGroupSaga(): any {
    yield takeLatest(eLegalGroupActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eLegalGroupActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eLegalGroupActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ILegalGroupActionTypes): any {
    const res: IBaseResponeModel = yield call(legalGroupApi.selectAll)

    if (res.is_success) {
        yield put(actions.legalDocument.group.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.legalDocument.group.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: ILegalGroupActionTypes): any {
    const res: IBaseResponeModel = yield call(legalGroupApi.delete, action.payload as number)

    if (res.is_success) {
        yield put(actions.legalDocument.group.DELETE_SUCESSS(res.data))
    } else {
        yield put(actions.legalDocument.group.DELETE_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: ILegalGroupActionTypes): any {
    const payload = action.payload as ILegalGroup;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(legalGroupApi.update, payload)
    } else {
        res = yield call(legalGroupApi.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.legalDocument.group.SAVE_SUCESSS(res.data))
    } else {
        yield put(actions.legalDocument.group.SAVE_ERROR(res.message ?? "Error"))
    }
}

